<template>
  <!-- 物流公司邮费管理 -->
  <div class="logisticsPostage">
    <!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title">
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd()"
          >新增邮费规则</el-button
        >
      </template>
    </page-header>

    <!-- 搜索框 -->
    <!-- <search-bar>
      <template>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入名称"
        ></el-input>
        <el-select
          style="width: 100px"
          v-model="searchForm.type"
          placeholder="状态"
          clearable
        >
          <el-option label="启用" value="Y"></el-option>
          <el-option label="禁用" value="N"></el-option>
        </el-select>
        <el-button
          style="margin-left: 10px"
          type="primary"
          icon="el-icon-search"
          @click="getTableData('search')"
          >搜索</el-button
        >
      </template>
    </search-bar> -->

    <div style="height: calc(100% - 40px)">
      <el-table
        :data="tableData"
        stripe
        border
        height="100%"
        tooltip-effect="dark"
      >
        <el-table-column label="序号" type="index" align="center" width="50">
        </el-table-column>
        <el-table-column
          align="center"
          prop="Id"
          show-overflow-tooltip
          label="ID"
        >
        </el-table-column>

        <el-table-column
          align="center"
          prop="Qybh"
          show-overflow-tooltip
          label="区域编号"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="Province"
          show-overflow-tooltip
          label="省份"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="City"
          show-overflow-tooltip
          label="城市"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="Area"
          show-overflow-tooltip
          label="县/区"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="GiveAmount"
          show-overflow-tooltip
          label="起配金额"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="XzAmount"
          show-overflow-tooltip
          label="免邮金额"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="Postage"
          show-overflow-tooltip
          label="邮费"
        >
        </el-table-column>
        <el-table-column
          width="150"
          align="center"
          prop="CientTypeName"
          show-overflow-tooltip
          label="客户类型"
        >
        </el-table-column>

        <el-table-column
          width="150"
          align="center"
          prop="Lastmodifytime"
          show-overflow-tooltip
          label="最后修改时间"
        >
        </el-table-column>

        <el-table-column align="center" prop="" label="操作" width="120px">
          <template v-if="scope.row.Status != '0'" slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              icon="el-icon-delete"
              @click="handleDel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 添加规则 -->
    <el-drawer
      title=""
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">
        <span v-if="submitType == 'add'">新增</span>
        <span v-else>编辑</span>
      </div>
      <el-scrollbar class="drawer-con">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="120px"
            :rules="formRule"
            ref="addForm"
          >
            <el-form-item label="区域：" prop="area">
              <el-cascader
                class="form-input"
                ref="areaAascader"
                v-model="addForm.area"
                placeholder="选择地址(可搜索)"
                :options="$store.state.citys"
                :props="{ value: 'label', label: 'label', checkStrictly: true }"
                filterable
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="邮费" prop="Postage">
              <el-input class="form-input" v-model="addForm.Postage"></el-input>
            </el-form-item>
            <el-form-item label="起配金额" prop="GiveAmount">
              <el-input
                class="form-input"
                v-model="addForm.GiveAmount"
              ></el-input>
            </el-form-item>
            <el-form-item label="免邮金额" prop="XzAmount">
              <el-input
                class="form-input"
                v-model="addForm.XzAmount"
              ></el-input>
            </el-form-item>
            <el-form-item label="客户类型" prop="userType">
              <!-- <div style="widht: 200px;">
                <el-checkbox-group v-model="addForm.userType" style="width: 1000px">
                <el-checkbox v-for="item in userTypeList" :key="item.value" :label="item.value">
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
              </div> -->
              <el-select
                class="form-input"
                :multiple="true"
                placeholder="请选择"
                v-model="addForm.userType"
              >
                <el-option
                  v-for="item in userTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submitForm">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//混入
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项

export default {
  name: "logisticsPostage",
  data() {
    return {
      entId: "",
      row: {}, //接受到的参数
      /**搜索表单 */
      searchForm: {
        type: "", //Y启用N禁用
        name: "",
      },
      /**表格数据 */
      tableData: [],

      addDrawer: false /**新增drawer */,
      /**表单数据 */
      //区域 下单金额门槛 折扣门槛 免邮门槛 邮费
      addForm: {
        id: "",
        area: [], //区域
        Postage: 0, //邮费
        XzAmount: 0, //免邮门槛
        GiveAmount: 0, //起配金额
        userType: [], //客户类型
      },
      submitType: "add", //提交类型，编辑还是新增
      /**表单验证 */
      formRule: {
        area: [mustFill],
        Postage: [mustFill],
        XzAmount: [mustFill],
        GiveAmount: [mustFill],
        userType: [mustFill],
      },

      /**客户类型 */
      userTypeList: [],
    };
  },

  mounted() {
    //判断是否接收到传过来的参数
    if (this.$route.params.row) {
      this.row = this.$route.params.row;
      this.entId = window.localStorage.getItem("entId");
      this.getTableData();
      this.getUserType();
    } else {
      this.$message({
        message: "未接收到必要参数",
        type: "warning",
      });
      let timer = setTimeout(() => {
        this.goBack();
        clearTimeout(timer);
        timer = null;
      }, 1000);
    }
  },

  methods: {
    /**返回 */
    goBack() {
      this.$router.go(-1);
    },

    /**获取表格_这个没有分页 */
    getTableData(type = "") {
      //函数太多 type: refresh search 不传参数默认加载
      if (type == "refresh") {
        // this.currPage = 1;
        this.searchForm.name = "";
        this.searchForm.type = "";
      } else if (type == "search") {
        // this.currPage = 1;
      }
      let data = {
        LogisticsCode: this.row.LogisticsCode,
      };

      this.$request({
        url: "Base/LogisticsRuleList",
        method: "post",
        data,
      })
        .then((res) => {
          this.tableData = res.list;
          this.allPage = res.toTal;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**客户类型获取 */
    getUserType() {
      let data = {
        type: "CustomType",
      };
      let proc = "Proc_Admin_CustomerList"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "coupon/ashx/returnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.userTypeList = res.data.map((item) => {
              return {
                label: item.clienttype,
                value: item.TypeID,
              };
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**新增 */
    handleAdd() {
      this.submitType = "add";
      this.clearForm();
      this.addDrawer = true;
    },

    /**编辑 */
    handleEdit(row) {
      this.submitType = "edit";

      this.addForm.id = row.Id;
      // 过滤值为null的市、区
      this.addForm.area = [row.Province, row.City, row.Area].filter((item) => {
        return Boolean(item);
      });
      //这里需要判断 省市区是否都有值
      this.addForm.Postage = row.Postage;
      this.addForm.XzAmount = row.XzAmount;
      this.addForm.GiveAmount = row.GiveAmount;
      this.addForm.GiveAmount = row.GiveAmount;
      this.addForm.userType = row.CientType.split(",");

      this.addDrawer = true;
    },

    /**删除 */
    handleDel(row) {
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$request({
            url: "Base/DltLogisticsRule",
            method: "post",
            data: {
              RuleId: row.Id,
            },
          })
            .then((res) => {
              let type = res.success ? "success" : "error";
              //提示成功，关闭dialog
              this.$message({
                message: type,
                type,
              });

              if (res.success) {
                this.getTableData("refresh");
              }
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**修改状态 */
    changeStatus(beactive) {
      //未选中判断
      if (this.selectedList.length == 0) {
        return;
      }

      let options = this.selectedList.map((item) => {
        return item.id;
      });

      this.$request({
        url: "Member/SystemInterceptSwitch",
        method: "post",
        data: {
          id: options.join(),
          beactive,
        },
      })
        .then((res) => {
          let type = res.success ? "success" : "error";
          //提示成功，关闭dialog
          this.$message({
            message: res.message,
            type,
          });

          if (res.success) {
            this.getTableData("refresh");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.addForm = {
        // area: [], //区域
        // orderAmount: 0, //下单金额门槛
        // discount: 0, //折扣门槛
        // freeShop: 0, //免邮门槛
        // postage: 0, //邮费
        // beactive: "Y", //启用禁用
        // payType: "", //支付类型

        id: "",
        area: [], //区域
        Postage: 0, //邮费
        XzAmount: 0, //免邮门槛
        GiveAmount: 0, //起配金额
        userType: "", //客户类型
      };
      this.addDrawer = false;
      if (this.$refs["addForm"]) {
        this.$refs["addForm"].resetFields();
      }
    },

    /**提交表单 */
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          //获取区域的编码
          let node = this.$refs.areaAascader.getCheckedNodes();
          console.log(node);
          let data = null;
          let url = "Base/SaveLogisticsRule";

          // let clientId = [];//客户类型id
          // let clientType = [];//客户类型名称
          let clientName = []; //选中客户类型名称组合
          this.userTypeList.forEach((item) => {
            console.log(this.addForm.userType.indexOf(item.value));
            if (this.addForm.userType.indexOf(item.value) > -1) {
              clientName.push(item.label);
            }
          });

          if (this.submitType === "add") {
            data = {
              id: 0,
              LogisticsCode: this.row.LogisticsCode,
              Qybh: node[0].data.value, //区域编号
              Province: this.addForm.area[0], //新疆,省份,
              City: this.addForm.area[1], //城市，无值传空
              Area: this.addForm.area[2], //县/区，无值传空
              Postage: this.addForm.Postage, //邮费
              XzAmount: this.addForm.XzAmount, //免邮门槛
              GiveAmount: this.addForm.GiveAmount, //起配金额
              CientType: this.addForm.userType.join(","), //客户类型
              CientTypeName: clientName.join("、"),
            };
          } else {
            data = {
              id: this.addForm.id,
              LogisticsCode: this.row.LogisticsCode,
              Qybh: node[0].data.value, //区域编号
              Province: this.addForm.area[0], //新疆,省份,
              City: this.addForm.area[1], //城市，无值传空
              Area: this.addForm.area[2], //县/区，无值传空
              Postage: this.addForm.Postage, //邮费
              XzAmount: this.addForm.XzAmount, //免邮门槛
              GiveAmount: this.addForm.GiveAmount, //起配金额
              CientType: this.addForm.userType.join(","), //客户类型
              CientTypeName: clientName.join("、"),
            };
          }

          this.$request({
            url,
            method: "post",
            data,
          }).then((res) => {
            let type = res.success ? "success" : "error";

            this.$message({
              message: type,
              type: type,
            });

            if (res.success) {
              //关闭drawer，清空表单，刷新数据
              this.clearForm();
              this.getTableData("refresh");
            }
          });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.logisticsPostage {
  width: 100%;
  height: 100%;
}

/**表格容器 */
.main {
  height: calc(100% - 130px);
}

/**抽屉 */
.drawer-con {
  height: calc(100% - 90px);
}

/**表单输入框 */
.form-input {
  width: 200px;
}
</style>
